import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import Dashboard from "./pages/Dashboard";
import TabelContracte from "./components/contracte/TabelContracte";
import TabelPartizi from "./components/partizi/TabelPartizi";
import AdaugContract from "./components/contracte/AdaugContract";
import AdaugPartida from "./components/partizi/AdaugPartida";
import Login from "./pages/Login";
import AdminUtilizatori from "./components/admin/AdminUtilizatori";
import SituatieExploatare from "./pages/SituatieExploatare";
import { useAuth } from "./context/AuthContext";
import { useFirestoreData } from "./hooks/useFirestoreData";

const App = () => {
  const { user } = useAuth();
  const { contracte, datePartizi, loading } = useFirestoreData(user);

  if (loading) {
    return (
      <div className="p-5 text-center">
        <div className="spinner-border" role="status"></div>
        <p>Se încarcă datele...</p>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <MainLayout>
      {(tema) => (
        <Routes>
          <Route
            path="/"
            element={
              <Dashboard
                date={contracte}
                tema={tema}
                partizi={datePartizi}
              />
            }
          />

          <Route
            path="/situatie-exploatare"
            element={
              <SituatieExploatare
                toatePartizile={datePartizi}
                tema={tema}
              />
            }
          />

          <Route
            path="/adaugPartida"
            element={<AdaugPartida tema={tema} />}
          />

          <Route
            path="/prestari"
            element={
              <TabelContracte
                titlu="Contracte Prestări"
                date={contracte}
                toatePartizile={datePartizi}
                tema={tema}
              />
            }
          />

          <Route
            path="/adaug"
            element={
              <AdaugContract
                tema={tema}
                partizi={datePartizi}
                user={user}
              />
            }
          />

          <Route
            path="/admin-utilizatori"
            element={
              user?.rol === "administrator" ? (
                <AdminUtilizatori />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/tabelPartizi"
            element={
              <TabelPartizi
                titlu="Gestiune Partizi"
                date={datePartizi}
                tema={tema}
                user={user}
              />
            }
          />
        </Routes>
      )}
    </MainLayout>
  );
};

export default App;